<template>
  <el-container class="screen-parameters screen-parameters-integration screen-parameters-fullHeight services">
    <el-row class="services-panel black-inputs">
      <el-col :span="20" :offset="2" class="services-container">
        <div class="nav-toggle" @click="showHideScreenIntegration">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
        <div class="screen-title">Integration</div>
        <div class="screen-block">
          <el-row :gutter="20">
            <el-col :span="5" style="height: 40px;">
              <div class="screen-sub-title">Integration</div>
            </el-col>
            <el-col :span="9" style="height: 40px;">Ancien formulaire</el-col>
            <el-col :span="1" style="height: 40px;"></el-col>
            <el-col :span="9" style="height: 40px;">Nouveau formulaire</el-col>

            <!-- Web -->
            <el-col :span="5" class="screen-label">Web : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('web') }}<i @click="copylink('web')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('web', true) }}<i @click="copylink('web', true)"
                class="el-icon-document-copy"></i></el-col>

            <!-- Instagram -->
            <el-col :span="5" class="screen-label">Instagram : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('instagram') }}<i @click="copylink('instagram')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('instagram', true) }}<i
                @click="copylink('instagram', true)" class="el-icon-document-copy"></i></el-col>

            <!-- Contenu caché -->
            <template v-if="showMore">
              <el-col :span="5" class="screen-label">Facebook : </el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('facebook') }}<i @click="copylink('facebook')"
                  class="el-icon-document-copy"></i></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('facebook', true) }}<i
                  @click="copylink('facebook', true)" class="el-icon-document-copy"></i></el-col>

              <el-col :span="5" class="screen-label">Google : </el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('google') }}<i @click="copylink('google')"
                  class="el-icon-document-copy"></i></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('google', true) }}<i
                  @click="copylink('google', true)" class="el-icon-document-copy"></i></el-col>

              <el-col :span="5" class="screen-label">Yelp : </el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('yelp') }}<i @click="copylink('yelp')"
                  class="el-icon-document-copy"></i></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('yelp', true) }}<i @click="copylink('yelp', true)"
                  class="el-icon-document-copy"></i></el-col>

              <el-col :span="5" class="screen-label">TripAdvisor : </el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('tripadvisor') }}<i
                  @click="copylink('tripadvisor')" class="el-icon-document-copy"></i></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('tripadvisor', true) }}<i
                  @click="copylink('tripadvisor', true)" class="el-icon-document-copy"></i></el-col>

              <el-col :span="5" class="screen-label">Influenceur : </el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('influencer') }}<i @click="copylink('influencer')"
                  class="el-icon-document-copy"></i></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9" class="screen-fake-input">{{ getLink('influencer', true) }}<i
                  @click="copylink('influencer', true)" class="el-icon-document-copy"></i></el-col>

              <el-col :span="5" class="screen-label">Iframe : </el-col>
              <el-col :span="19" class="screen-fake-input">{{ getLink('iframe') }}<i @click="copylink('iframe')"
                  class="el-icon-document-copy"></i></el-col>
            </template>

            <!-- Bouton Voir Plus -->
            <el-col :span="24" class="text-center" style="margin-top: 20px;">
              <el-button type="text" @click="toggleShowMore">{{ showMore ? 'Voir moins' : 'Voir plus' }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Integration',
  data() {
    return {
      showCreateMainService: false,
      formCreateMainService: {
        name: ''
      },
      formatedDataServices: {},
      showMore: false
    }
  },
  computed: {
    ...mapGetters({
      getUidPublic: 'newUsers/getUidPublic'
    })
  },
  methods: {
    ...mapActions({
      showHideScreenIntegration: 'displayer/showHideScreenIntegration'
    }),
    getLink(origin, isNew = false) {
      if (origin === 'iframe') {
        return this.getIframeLink()
      }
      let host = `https://${window.location.hostname}`
      let bookingPath = isNew ? '/booking-new/' : '/booking/'
      return `${host + bookingPath + origin.toString()}/${this.getUidPublic}`
    },
    getIframeLink() {
      let host = `https://${window.location.hostname}`
      let bookingPath = '/booking-iframe/'
      const href = `${host + bookingPath}web/${this.getUidPublic}`
      return `<iframe style="border: none;" height="630" width="400" title="resa.ninja" src="${href}"></iframe>`
    },
    toggleShowMore() {
      this.showMore = !this.showMore
    },
    async copylink(el, isNew = false) {
      const link = this.getLink(el, isNew)
      try {
        await navigator.clipboard.writeText(link)
        Notification.success({
          title: 'Lien copié',
          message: 'Le lien à été copié avec succès',
          position: 'bottom-right'
        })
      } catch (err) {
        console.error('Failed to copy: ', err)
      }
    },

    getWebIntegration: function () {
      // TODO: set width and height
      let iframe = `<iframe id="resaninja-frame" name="resaninja-frame-web" frameborder="0" hspace="0" scrolling="auto" src="${this.getLink('web')}"></iframe>`
      return iframe
    }
  }
}
</script>

<style lang="scss"></style>
